import { COLOR1, RADIO_COLOR, ORIENTAL_D_GRAY } from '../../../constants';

export const emplomentStyles = {
  employment_select_field_padding: {
    // paddingRight: '50px',
    display: 'flex',
    flexDirection: 'column',
    // paddingBottom: '10px',
    padding: '8px',
    '@media (max-width:960px)': {
      paddingRight: '0',
    },
    '@media (max-width:600px)': {
      paddingRight: '0',
    },
  },

  bundle_employment_select_field: {
    marginTop: '24px',
    '@media (max-width:600px)': {
      marginTop: '16px',
    },
  },

  select_inputs_err_bundle: {
    '& fieldset': {
      borderRadius: '30px !important',
      border: '1px solid #FD0000 !important',
    },
  },

  outline_inputs_err_bundle: {
    borderRadius: '30px !important',
    border: '1px solid #FD0000 !important',
  },

  select_inputs_bundleBorder: {
    border: '1px solid #E4E9F2',
    borderRadius: '30px !important',
    '& fieldset': {
      border: 'none',
    },
  },

  input_disabled_style: {
    '&.MuiInputBase-root.Mui-disabled': {
      background: '#EEEEEE !important',
      border: '1px solid #E2E2E2',
      cursor: 'none !important',
    },
  },

  select_inputs: {
    height: '48px',
    background: '#FFFFFF',
    border: '1px solid #E4E9F2',
    borderRadius: '6px',
    textAlign: 'left',
    color: COLOR1,
    font: 'normal normal 400 16px/18px Arial',
    letterSpacing: '0.1px',
    opacity: 1,
    '& .MuiOutlinedInput-input': {
      padding: '11.5px 14px',
    },
    '::placeholder': {
      color: ORIENTAL_D_GRAY,
      opacity: 0.8,
    },
    '::-webkit-input-placeholder': {
      color: ORIENTAL_D_GRAY,
      opacity: 0.8,
    },
    '::-moz-placeholder': {
      color: ORIENTAL_D_GRAY,
      opacity: 0.8,
    },
    ':-ms-input-placeholder': {
      color: ORIENTAL_D_GRAY,
      opacity: 0.8,
    },
  },

  select_inputs_err: {
    '& fieldset': {
      borderRadius: '6px',
      border: '1px solid #FD0000 !important',
    },
  },

  select_icon: {
    color: RADIO_COLOR,
    opacity: 1,
    '@media (max-width:340px)': {
      right: 0,
    },
  },

  select_inputs_placeholder: {
    background: '#FFFFFF',
    borderRadius: '6px',
    textAlign: 'left',
    fontWeight: 300,
    lineHeight: '20px',
    fontStyle: 'normal',
    fontSize: '16px',
    letterSpacing: '0.1px',
    color: ORIENTAL_D_GRAY,
    opacity: 0.8,
  },

  select_style: {
    background: 'rgba(85, 88, 88, 0.02) 0% 0% no-repeat padding-box',
    textAlign: 'left',
    fontWeight: 300,
    lineHeight: '16px',
    fontStyle: 'normal',
    fontSize: '14px',
    letterSpacing: '0.1px',
    color: COLOR1,
    opacity: 1,
    '@media (max-width:600px)': {
      fontSize: '16px',
      lineHeight: '20px',
    },
  },

  employmentCardContainer: {
    borderRadius: '6px',
    border: '1px solid #E6E6E6',
    background: '#FFF',
  },

  employmentcardcontent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    gap: '18px',
  },

  employmentCardText: {
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: '700',
    fontSize: '16px',
    lineHeight: 'normal',
    textAlign: 'center',
  },
};
